import {
  Box,
  Container,
  Flex,
  Heading,
  Link,
  SimpleGrid,
  Stack,
} from '@chakra-ui/react';
import { Card, Divider, Image, Text } from '@diamond/shared/ui';
import NextImage from 'next/image';
import NextLink from 'next/link';

interface SolBuyerAuthenticationLayoutProps {
  children: React.ReactNode;
  pageTitle: string;
  withActionLink?: {
    label: string;
    href: string;
  };
}

export function SolBuyerAuthenticationLayout({
  children,
  pageTitle,
  withActionLink,
}: SolBuyerAuthenticationLayoutProps) {
  return (
    <Box>
      <Container
        as={SimpleGrid}
        maxW="6xl"
        minH="100vh"
        columns={{ base: 1, md: 2 }}
        spacing={{ base: 10, lg: 32 }}
        pt={{ base: 6, md: 'unset' }}
        pb={{ base: 10, md: 'unset' }}
      >
        <Flex align={{ base: 'unset', md: 'center' }} justify="center">
          <Card flex="1">
            <Stack>
              <Stack spacing={4}>
                <Heading lineHeight={1.1}>
                  <Stack direction="row">
                    <Image
                      as={NextImage}
                      src="/images/logo.png"
                      alt="logo"
                      h={{ base: '32px', md: '62px' }}
                      w={{ base: '80px', md: '148px' }}
                    />
                    <Stack
                      align="center"
                      justify="center"
                      spacing="-1"
                      color="navy"
                      fontSize={{ base: 'sm', md: '2xl' }}
                    >
                      <Text my="1">SUKANDA</Text>
                      <Text>ONELINK</Text>
                    </Stack>
                  </Stack>
                </Heading>
              </Stack>
              <Box py="2">
                <Text as="h1" fontSize="xl" fontWeight="bold">
                  {pageTitle}
                </Text>
                <Stack direction="row" alignItems="flex-end">
                  {withActionLink?.href === '/aktivasi' ? (
                    <Text fontSize={{ base: 'xs', md: 'md' }}>
                      Belum punya akun Sukanda OneLink?
                    </Text>
                  ) : (
                    <Text fontSize={{ base: 'xs', md: 'md' }}>
                      Sudah punya akun Sukanda OneLink?
                    </Text>
                  )}
                  {withActionLink && (
                    <NextLink
                      href={withActionLink.href}
                      legacyBehavior
                      passHref
                    >
                      <Link
                        color="blue"
                        fontWeight="semibold"
                        fontSize={{ base: 'sm', md: 'md' }}
                      >
                        {withActionLink.label}
                      </Link>
                    </NextLink>
                  )}
                </Stack>
                <Divider pt="2" />
              </Box>
              {children}
            </Stack>
          </Card>
        </Flex>
        <Flex
          flex={1}
          align="center"
          justify="center"
          display={{ base: 'none', md: 'flex' }}
        >
          <Card rounded="3xl" m="unset">
            <Image
              as={NextImage}
              src="/images/login.png"
              alt="SUKANDA ONELINK"
              objectFit="cover"
              width={527}
              height={750}
            />
          </Card>
        </Flex>
      </Container>
    </Box>
  );
}
